import { createStore } from 'vuex'

export default createStore({
  state: {
    isLoggedIn: false // 登录状态
  },
  mutations: {
    SET_LOGIN_STATE(state, status) {
      state.isLoggedIn = status
    }
  },
  actions: {
    updateLoginState({ commit }, status) {
      commit('SET_LOGIN_STATE', status)
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn
  }
})